import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const NumeroDocumentoPagoFormGroup = ({ iTouched, iError, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select-flujoEfectivo', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='N° DOC' htmlFor='input-numeroDocumentoPago' md={12} />
      <Col md={12}>
        <Field name='numeroDocumentoPago'>
          {({ field }) => (
            <Form.InputText {...field} id='input-numeroDocumentoPago' isInvalid={iTouched && iError} disabled={fIsSubmitting} onKeyDown={onKeyDown} />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoPagoFormGroup)
